/**
 * Meetings Details
 * Talkroute
 *
 * Created by Vel Genov on 07/22/21
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * The external dependencies
 */
import React from "react";
import { Dimmer, Grid, Loader } from "semantic-ui-react";

/**
 * The internal dependencies
 */
import MeetingActions from "./Actions";
import { isIOS } from "@constants/appConstants";
import { MEETINGS_TEXT } from "@components/Meetings/constants";
import { TitleNormal } from "@components/Global/Heading/styles";

/**
 * Styles
 */
import {
  MeetingViewWrap,
  MeetingView,
} from "@components/Meetings/Details.styles";
import { useAppSelector } from "@helpers/hooks/useAppSelector.hook";
import { useGetAllMeetingsQuery } from "@services/Moxtra.slice";

/**
 * Draw the main content
 * @param children JSX to display in the content section
 */
const showContent = (children) => {
  return (
    <MeetingViewWrap>
      <MeetingView>{children}</MeetingView>
    </MeetingViewWrap>
  );
};

/**
 * Meetings Details Component
 */
export default function MeetingsDetails() {
  let WebkitAppRegion = "inherit";
  if (isIOS) WebkitAppRegion = "drag";
  const {isLoading: isFetchingScheduledMeetings} = useGetAllMeetingsQuery();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
      }}
    >
      {/* Header */}
      <Grid
        style={{
          minHeight: "60px",
          height: "60px",
          WebkitAppRegion,
          zIndex: 5,
          margin: 0,
          borderBottom: "1px solid var(--color-dark-grey)",
        }}
      >
        <Grid.Column
          verticalAlign="middle"
          style={{
            width: "100%",
            display: "flex",
            textAlign: 'center',
          }}
        >
          <TitleNormal style={{fontSize: 21}} className="none-select-text">
            {MEETINGS_TEXT}
          </TitleNormal>
        </Grid.Column>
      </Grid>
      {isFetchingScheduledMeetings &&<Dimmer
        active
        style={{ height: "100%",
        width: "calc(100vw - 250px)",
        zIndex: 5,
        transform: "translateX(-300px)" }}
      >
          <Loader />
      </Dimmer>}
      {showContent(<MeetingActions />)}
    </div>
  );
}
